/*
    We maintain a list of most recently used 5 tables by storing the tablesId in the MRU list.
    Whenever a new table is added to the MRU, we subscribe to the row notifications.
    Whenever a table id entry is removed from the MRU we unsubscribe to the row notifications.
    This means at any time only 5 tables are active\live.
    VSO-18425 - Use mruCache class from client-framework instead
*/
var tableIdList;
var capacity = 5;
var onAdd;
var onRemove;
function add(tableView) {
    tableIdList.unshift(tableView.id);
    onAdd(tableView);
    invalidateOldEntries();
}
function bumpToFront(tableView) {
    var entry = tableView.id;
    tableIdList.splice(tableIdList.indexOf(entry), 1);
    tableIdList.unshift(entry);
}
function invalidateOldEntries() {
    if (tableIdList.length > capacity) {
        for (var i = capacity; i < tableIdList.length; i++) {
            remove(tableIdList[i]);
        }
    }
}
export function initialize(onAddCallback, onRemoveCallback, listCapacity) {
    tableIdList = [];
    onAdd = onAddCallback;
    onRemove = onRemoveCallback;
    capacity = listCapacity;
}
/**
 * Removes entry from the MRU table id list
 * @param tableViewId the id of tableView
 */
export function remove(tableViewId) {
    var index = tableIdList.indexOf(tableViewId);
    if (index == -1) {
        throw new Error('TableViewId should be present in the mru list when remove is called');
    }
    tableIdList.splice(index, 1);
    onRemove(tableViewId);
}
export function update(tableView) {
    var entryIndex = tableIdList.indexOf(tableView.id);
    switch (entryIndex) {
        case -1:
            add(tableView);
            break;
        case 0:
            break;
        default:
            bumpToFront(tableView);
    }
    return entryIndex;
}
export function getMRUTableId() {
    return tableIdList ? tableIdList[0] : null;
}
export function canAddToList() {
    return tableIdList.length < capacity;
}
//# sourceMappingURL=mruTableIdList.js.map